module.exports = __webpack_public_path__ + "img/mic.f3a819c2.svg";